// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__mVU4-","noInteraction":"EventWrapper_noInteraction__2PjkI"};